// Editor-only snapshots: exclude React Flow measurements and selection state.
/** Purpose: Transform editor snapshot in the editor tools module. Why: This keeps the surrounding interface operation aligned with the expected data shape. */
export const editorSnapshot = (state) => JSON.stringify({
  nodes: state.nodes.map(({ selected, dragging, width, height, positionAbsolute, ...node }) => node),
  edges: state.edges.map(({ selected, ...edge }) => edge),
  variables: state.variables, flowName: state.flowName, flowDescription: state.flowDescription,
  entryNodeId: state.entryNodeId,
});

/** Purpose: Resolve localized messages and options for preview. Why: Preview translations must not replace the saved localization references. */
export const previewConfig = (config = {}, localization, language) => {
  /** Purpose: Read a translation with the bundle's default-language fallback. Why: Missing translations should not blank usable preview content. */
  const lookup = (key) => {
    const entry = localization?.entries?.find((item) => item.key === key);
    return entry?.values?.[language] || entry?.values?.[localization?.defaultLanguage] || '';
  };
  const value = lookup(config.localizationKey);
  return {
    ...config,
    ...(value ? { message: value, prompt: value, localizationKey: '' } : {}),
    ...(Array.isArray(config.options) ? { options: config.options.map((option) => {
      if (!option || typeof option !== 'object') return option;
      const title = lookup(option.localizationKey);
      return title ? { ...option, title, localizationKey: '', previewKey: option.localizationKey } : option;
    }) } : {}),
  };
};

/** Purpose: Collect missing connections and stale catalog references. Why: Authors need configuration warnings before executing or publishing. */
export const editorWarnings = (node, edges, localization, functions, flows = []) => {
  const config = node.data?.config || {};
  const warnings = [];
  if (node.type !== 'end' && !edges.some((edge) => edge.source === node.id)) warnings.push('No outgoing connection');
  const keys = [config.localizationKey, ...(Array.isArray(config.options) ? config.options : []).map((option) => option?.localizationKey)].filter(Boolean);
  if (localization && keys.some((key) => !localization.entries?.some((entry) => entry.key === key))) warnings.push('Missing localization key');
  if (config.functionDefinitionId && functions && !functions.some((fn) => (fn.functionId || fn._id) === config.functionDefinitionId)) warnings.push('Missing saved function');
  if (config.targetFlowId && Array.isArray(flows) && flows.length > 0 && !flows.some((flow) => flow.flowId === config.targetFlowId || String(flow._id) === config.targetFlowId || flow.name === config.targetFlowId)) {
    warnings.push('Missing target flow');
  }
  return warnings;
};
